import { render, staticRenderFns } from "./ChangeProfileImage.vue?vue&type=template&id=ef64b4bc&scoped=true"
import script from "./ChangeProfileImage.vue?vue&type=script&lang=js"
export * from "./ChangeProfileImage.vue?vue&type=script&lang=js"
import style0 from "./ChangeProfileImage.vue?vue&type=style&index=0&id=ef64b4bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef64b4bc",
  null
  
)

export default component.exports